import { useQuery } from "@tanstack/react-query";

import { mutateData } from "@/core/api/api-methods";
import type { ListRequest, Paged } from "@/core/api/pagination";
import { QUERY_KEYS } from "@/core/api/query-keys";
import { walletEndpoints } from "@/features/wallet/api/endpoints";
import type {
  TransactionDto,
  TransactionFilter,
} from "@/features/wallet/api/dto";

/**
 * Historique paginé des transactions (`POST /Transactions/all` — les listes
 * sont en POST, guide §4.2). Lecture authentifiée : `mutateData` en queryFn,
 * la requête reste une query TanStack (cache, invalidation).
 */
export const useTransactions = (
  params: ListRequest<TransactionFilter> = {},
  enabled = true
) =>
  useQuery({
    queryKey: QUERY_KEYS.WALLET_TRANSACTIONS_LIST(params),
    queryFn: () =>
      mutateData({
        url: walletEndpoints.transactions.all,
        reqBody: params as unknown as Record<string, unknown>,
        method: "POST",
      }) as Promise<Paged<TransactionDto>>,
    enabled,
  });
